import React, { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { SvgImage } from 'components/SvgImage'
import {
  TERMS_LINKS_GROUP_VARIANT,
  TermsLinksGroup,
} from 'components/TermsLinksGroup'

import { useDelayedContinue } from 'hooks/useDelayedContinue'
import { useNextStep } from 'hooks/useNextStep'

import { TPageProps } from 'models/common.model'

import chevronRightIcon from 'assets/images/sprite/chevron-right.svg'

import { Language, OptionType } from 'root-constants'

import { StyledSelectFamilySize as S } from './SelectFamilySize.styles'
import { FAMILY_SIZE_OPTIONS } from './constants'

export const SelectFamilySize: React.FC<TPageProps> = ({
  pageId,
  nextPagePath,
  isFirstPage,
}) => {
  const { t } = useTranslation()
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const [answer, setAnswer] = useState<string>('')

  const handleContinue = useNextStep({
    pageId,
    question: t('onboarding.selectFamilySize.question', { lng: Language.EN }),
    nextPagePath,
    isFirstPage,
  })

  const handleAnswerChange = (value: string) => {
    handleChange(value, handleContinue)
    setIsAnswersDisabled(true)
    setAnswer(value)
  }

  return (
    <S.Wrapper>
      <S.Title>
        <Trans i18nKey="onboarding.selectFamilySize.title" />
      </S.Title>
      <S.QuizLabel>{t('onboarding.selectFamilySize.quizLabel')}</S.QuizLabel>
      <S.Question>{t('onboarding.selectFamilySize.question')}</S.Question>

      <S.Options>
        {FAMILY_SIZE_OPTIONS.map(({ value, text }) => (
          <S.Option
            key={value}
            name={pageId}
            value={value}
            type={OptionType.RADIO}
            checked={answer === value}
            disabled={isAnswersDisabled}
            onChange={handleAnswerChange}
            withoutMargin
          >
            {t(text)}
            <S.ArrowBadge $isActive={answer === value}>
              <SvgImage svg={chevronRightIcon} width={20} height={20} />
            </S.ArrowBadge>
          </S.Option>
        ))}
      </S.Options>

      <S.Terms>
        <TermsLinksGroup
          titleKey="commonComponents.termsTitle"
          variant={TERMS_LINKS_GROUP_VARIANT.DARK}
        />

        <S.TermsNote>{t('commonComponents.termsNote')}</S.TermsNote>
      </S.Terms>
    </S.Wrapper>
  )
}
